import { Phone, MessageSquare } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PHONE, PHONE_HREF, ADDRESS } from "@/data/site";

const schema = {
  "@context": "https://schema.org",
  "@type": "Plumber",
  name: "Irvine Water Heater Man",
  telephone: "+19493715993",
  address: { "@type": "PostalAddress", streetAddress: "21 Alexandria", addressLocality: "Irvine", addressRegion: "CA", postalCode: "92614" },
  areaServed: ["Irvine CA", "Tustin CA", "Lake Forest CA", "Newport Beach CA", "Costa Mesa CA", "Orange County CA"],
  openingHours: "Mo-Su 00:00-24:00",
  priceRange: "$$",
  url: "https://irvinewaterheaterman.com",
  description: "Water heater installation, repair, and replacement in Irvine, CA. Tank and tankless, gas and electric. 24/7 emergency service across Orange County.",
};

const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    <Header />
    <main className="flex-1 pb-16 sm:pb-0">{children}</main>
    <Footer />
    <div className="fixed bottom-0 inset-x-0 z-50 sm:hidden grid grid-cols-2 shadow-[0_-4px_20px_rgba(0,0,0,0.15)]" data-testid="mobile-sticky-bar">
      <a href={PHONE_HREF} data-testid="sticky-call-btn" className="flex items-center justify-center gap-2 bg-[#FF6500] text-white font-heading font-bold py-4">
        <Phone className="w-5 h-5" /> Call {PHONE}
      </a>
      <a href="#quote" data-testid="sticky-quote-btn" onClick={(e) => { e.preventDefault(); document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" }); }} className="flex items-center justify-center gap-2 bg-[#0B192C] text-white font-heading font-bold py-4">
        <MessageSquare className="w-5 h-5" /> Free Estimate
      </a>
    </div>
  </div>
);

export default Layout;
